

import {Component, Prop, Vue} from "vue-property-decorator";
import Restaurant from "../../domain/restaurant/Restaurant";

@Component
export default class RestaurantContactCard extends Vue{

  @Prop({default: null})
  restaurant!: Restaurant | null;

  @Prop({default: true})
  acceptsOnlineBookings!: boolean;


  get restaurantHasEmail() {
    return (
        this.restaurant != null &&
        this.restaurant.email != null &&
        this.restaurant.email !== ""
    );
  }

  get restaurantHasPhone() {
    return (
        this.restaurant != null &&
        this.restaurant.phoneNumber != null &&
        this.restaurant.phoneNumber !== ""
    );
  }

  get restaurantHasMaps() {
    return (
        this.restaurant != null &&
        this.restaurant.maps != null &&
        this.restaurant.maps !== ""
    );

  }

  get restaurantHasNotes() {
    return (
        this.restaurant != null &&
        this.restaurant.notes != null &&
        this.restaurant.notes !== ""
    );

  }

  get loading(){
    return this.restaurant === null;
  }


}
